import {Record} from 'immutable';
import moment from 'moment-timezone';

const MealTypeModel = Record({
    id: String(),
    institutionId: String(),
    title: String(),
    createdAt: Object(), // moment
    color: 0,
});

const mealTypeFromAPI = data => {
    return new MealTypeModel({
        ...data,
        createdAt: moment(data.createdAt),
    });
};

export const MealType = {
    record: MealTypeModel,
    fromAPI: mealTypeFromAPI,
};

export default {
    MealType,
};
